import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

// import Pagination from "../../components/Pagination";

import useStore from "../../store";
import api from "../../services/api";

export default function List() {
  const [users, setUsers] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);

  const { user } = useStore();

  const navigate = useNavigate();

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async (e) => {
    try {
      const { data } = await api.post("user/search", {});
      setUsers(data.users);
      setTotal(data.total);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= total) {
      setCurrentPage(newPage);
    }
  };

  if (user.role !== "admin") return <Navigate to="/" />;

  if (!users) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Users</h1>
        <Link
          to="/user/add"
          className="bg-black hover:bg-gray-700 text-white py-2 px-4 rounded"
        >
          Create new user
        </Link>
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6">
        <table className="w-full text-left border-collapse mb-5 table-fixed">
          <thead className="text-sm text-gray-400 border-b">
            <tr>
              <th className="py-2">Name</th>
              <th className="py-2">Username</th>
              <th className="py-2">Job title</th>
              <th className="py-2">Role</th>
              <th className="py-2">Created at</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {users.map((user) => (
              <tr
                className="hover:bg-gray-50 cursor-pointer border-b"
                onClick={() => navigate(`/user/${user.id}`)}
              >
                <td className="p-2 py-3">{user.name}</td>
                <td className="p-2 py-3">{user.username}</td>
                <td className="p-2 py-3">{user.job_title}</td>
                <td className="p-2 py-3">{user.role}</td>
                <td className="p-2 py-3">{user.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* <Pagination
          currentPage={currentPage}
          totalPages={total}
          onPageChange={handlePageChange}
        /> */}
      </div>
    </div>
  );
}
